var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86003 9.33333V12.6667M12.5267 7.66667V12.6667M9.19336 4.33333V12.6667M5.69336 16H12.6934C14.0935 16 14.7936 16 15.3283 15.7275C15.7987 15.4878 16.1812 15.1054 16.4209 14.635C16.6934 14.1002 16.6934 13.4001 16.6934 12V5C16.6934 3.59987 16.6934 2.8998 16.4209 2.36502C16.1812 1.89462 15.7987 1.51217 15.3283 1.27248C14.7936 1 14.0935 1 12.6934 1H5.69336C4.29323 1 3.59316 1 3.05838 1.27248C2.58798 1.51217 2.20553 1.89462 1.96584 2.36502C1.69336 2.8998 1.69336 3.59987 1.69336 5V12C1.69336 13.4001 1.69336 14.1002 1.96584 14.635C2.20553 15.1054 2.58798 15.4878 3.05838 15.7275C3.59316 16 4.29323 16 5.69336 16Z",
    stroke: "#4858A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveChartIcon);
export default __webpack_public_path__ + "static/media/active-chart-icon.d3e696a5c3ea8bec2e175e37a146b4ef.svg";
export { ForwardRef as ReactComponent };